import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import type { InstitutionKycCddOrDefaults } from '@/features/institution/kyc-cdd/schema';

const InstitutionKycCddFieldsetOwnershipAndRisk = () => {
  const form = useFormContext<InstitutionKycCddOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="identifiesUbos"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.ownershipAndRisk.identifiesUbos')}*</FormLabel>
            <FormControl>
              <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.kycCdd.ownershipAndRisk.identifiesUbos')} onValueChange={field.onChange}>
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="verifiesRelatedParties"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.ownershipAndRisk.verifiesRelatedParties')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.kycCdd.ownershipAndRisk.verifiesRelatedParties')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="assignsRiskClassification"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.kycCdd.ownershipAndRisk.assignsRiskClassification')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.kycCdd.ownershipAndRisk.assignsRiskClassification')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionKycCddFieldsetOwnershipAndRisk.displayName = 'InstitutionKycCddFieldsetOwnershipAndRisk';

export { InstitutionKycCddFieldsetOwnershipAndRisk };
